var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#AAF0C1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.2,44.1l-8.4-8.4c-0.6-0.6-1.6-0.6-2.2,0l-1.9,1.9c-0.6,0.6-0.6,1.6,0,2.2l8.4,8.4c0.6,0.6,1.6,0.6,2.2,0l1.9-1.9   C48.8,45.7,48.8,44.7,48.2,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4,34.1l-7.3-7.3c5-6.1,4.6-15.2-1.1-20.9c-6.1-6.1-16-6.1-22.1,0c-6.1,6.1-6.1,16,0,22.1c5.7,5.7,14.7,6.1,20.9,1.1   l7.3,7.3c0.1-0.1,0.1-0.2,0.2-0.2l1.9-1.9C36.2,34.2,36.3,34.1,36.4,34.1z M26.6,26.6c-5.3,5.3-13.9,5.3-19.3,0   C2,21.3,2,12.6,7.3,7.3C12.6,2,21.3,2,26.6,7.3S31.9,21.3,26.6,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6,17.6h-1.5c-1.1,0-1.6-1.3-0.8-2l2.7-2.5c-0.2,0-2.4,0.6-0.2-3.2c0,0-1.7,1.7-2,0.7c0,0-2.2,1.8-1.5-0.7l-1.1,1.4   c-0.4,0.5-1.2,0.2-1.2-0.4l0.1-2.2c0,0-1.2,2.3-2.4-2.1c0,0,0,2.5-0.9,1.9c0,0-0.3,2.9-1.5,0.5l0.3,2.4c0.1,0.7-0.7,1-1.2,0.5   l-1.6-1.7c0,0.2,0.6,2.4-3.2,0.2c0,0,1.7,1.7,0.7,2c0,0,1.8,2.2-0.7,1.4l2.2,1.7c0.9,0.7,0.4,2.1-0.7,2.1H9.3c0,0-0.8,1.9-3.4,2.3   c0,0,3,0.2,2.5,0.9c0,0,3,0.1,1.2,1.6c0.4-0.2,5.2-2.7,3.4,1l1.3-0.9c0.8-0.5,1.3-1.2,1.7-2l0,0c0.1-0.1,0.1-0.2,0.2-0.3   c0,0.2-0.1,0.4-0.1,0.7c-0.2,1.2-0.4,2.4-0.6,3.5c-0.2,1.1-0.5,2.2-0.9,3.1h1.9c0.3-1,0.4-1.9,0.5-2.8c0.1-1.2,0.2-2.4,0.3-3.7   c0-0.3,0-0.6,0-0.9c0.2,0.1,0.4,0.3,0.4,0.5c0.3,0.8,0.9,1.5,1.7,2l1.3,0.9c-1.8-3.7,3-1.2,3.4-1c-1.7-1.5,1.2-1.6,1.2-1.6   C25,20.1,28,19.9,28,19.9C25.4,19.5,24.6,17.6,24.6,17.6z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.82040a755eb5be02f6d94e34da4c0a2c.svg";
export { ForwardRef as ReactComponent };